import { render, staticRenderFns } from "./AttachmentsBlockGeodesia.vue?vue&type=template&id=afc38c60"
import script from "./AttachmentsBlockGeodesia.vue?vue&type=script&lang=js"
export * from "./AttachmentsBlockGeodesia.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports